
import React from 'react';
import { SaasInstance } from '@/types/userRole';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import InstanceTableRow from './instance-table/InstanceTableRow';
import InstanceTableEmptyState from './instance-table/InstanceTableEmptyState';

interface InstanceTableProps {
  instances: SaasInstance[];
  handleManageInstance: (instanceId: string) => void;
  handleVisitInstance: (domain: string) => void;
  handleSuspendInstance: (instanceId: string, currentStatus: string) => void;
  handleManagePayments: (instanceId: string) => void;
}

const InstanceTable: React.FC<InstanceTableProps> = ({
  instances,
  handleManageInstance,
  handleVisitInstance,
  handleSuspendInstance,
  handleManagePayments
}) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Instance</TableHead>
            <TableHead>Domain</TableHead>
            <TableHead>Plan</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {instances.length === 0 ? (
            <InstanceTableEmptyState />
          ) : (
            instances.map((instance) => (
              <InstanceTableRow 
                key={instance.id}
                instance={instance}
                onManage={handleManageInstance}
                onVisit={handleVisitInstance}
                onToggleSuspend={handleSuspendInstance}
                onManagePayments={handleManagePayments}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default InstanceTable;
